import { render, staticRenderFns } from "./WeightUnitField.vue?vue&type=template&id=1498da78&"
import script from "./WeightUnitField.vue?vue&type=script&lang=ts&"
export * from "./WeightUnitField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports